module.exports = __webpack_public_path__ + "static/media/notification.c25c46b7.svg";